export default __webpack_public_path__ + "static/media/search.15668d79.svg";